enum GoodsQualityEnum
{
    NEW = "NEW",
    NEWISH = "NEWISH",
    USED = "USED",
}

export default GoodsQualityEnum;
